import { forwardRef, ReactNode } from "react";
import * as SC from "./value.styles";

export interface ValueProps {
  children: ReactNode | string;
}

export const Value = forwardRef<HTMLDivElement, ValueProps>(
  ({ children }, ref) => {
    if (typeof children === "string") {
      return <SC.BuiltInValue ref={ref}>{children}</SC.BuiltInValue>;
    }

    return <>{children}</>;
  }
);

Value.displayName = "Dropdown.Value";
